import React, { useState, useEffect } from 'react'

// !! currently handles up to 39 sites to be selected !!

// JSAcl access is based on JSCustomerProject id (Site) 

const AccessSelect = props => {

  const { sites, handleAccessChange, access, userEdit,  bRole, customerId } = props;

  const [sitesToDisplay, setSitesToDisplay] = useState([]);

  useEffect(() => {
    if(sites && sites.length > 0){
      let tempSites = [...sites];

      // unless we are role of master admin we should only be able to view site access for the customer to which our user is assigned
      if(bRole !== 1 && customerId !== 'none'){
        tempSites = tempSites.filter(s => s.bCustomerID === parseInt(customerId));
      };

      setSitesToDisplay(tempSites);
    };
  }, [sites, bRole, customerId]);

  return (
    <div style={{ width: '50%', borderRight: '2px solid grey', paddingRight: '2vmin',paddingLeft: '2vmin' }}>
      <p style={{ marginTop: '1vmin', marginBottom: '1vmin', fontSize: '1.4vmin', fontWeight: 'bold', textDecoration: "underline" }}>{`Site Access (required)`}</p>

      <div style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>  
        <div style={{ textAlign: 'left', marginRight: '2vmin' }}>


          {sitesToDisplay && sitesToDisplay.length > 0 &&
              sitesToDisplay.map(s => (
                <div key={s.bID} style={{ display: "flex", alignItems: 'center', marginBottom: '.5vmin' }}>
                  <input 
                    type="checkbox" 
                    id={s.bID} 
                    name={s.sName} 
                    value={s.bID} 
                    checked={access.includes(s.bID.toString())}
                    style={{ cursor: 'pointer', height: userEdit ? '1.4vmin' : '1.6vmin', width: userEdit ? '1.4vmin' : '1.6vmin' }}
                    onChange={e => handleAccessChange(e)}/>
                  <span style={{ marginLeft: '1vmin', fontSize: userEdit ? '1.4vmin' : '1.6vmin' }}>{s.sName}</span>
                </div>
              )) 
          }
        </div>

      </div>
    </div>
  )
}

export default AccessSelect;